import store from '@/store';

export default function hasPermission(name) {
  const user = store.getters['app/currentUser'];
  const roles = (user && user.permission_list) || [];
  return roles.indexOf(name) !== -1 || false;
}

export function hasCustomFieldPermission(name) {
  const user = store.getters['app/currentUser'];
  const permissions = (user && user.custom_field_permissions) || [];
  return permissions.indexOf(name) !== -1;
}
